import api from "api/api";

export const createMissionFeeQuery = async ({ data, userScope }) =>
  await api.post(`/mission-fee?scope=${userScope}`, data);

export const getMissionFeeByIdQuery = async ({ id, userScope }) =>
  await api.get(`/mission-fee/${id}?scope=${userScope}`);

export const getMissionFeeByMissionIdQuery = async ({ id, userScope }) =>
  await api.get(`/mission-fee/mission/${id}?scope=${userScope}`);

export const editMissionFeeQuery = async ({ id, data, userScope }) =>
  await api.put(`/mission-fee/${id}?scope=${userScope}`, data);

export const deleteMissionFeeQuery = async ({ id, userScope }) =>
  await api.delete(`/mission-fee/${id}?scope=${userScope}`);

export const bulkEditMissionFeeQuery = async ({ id, data, userScope }) =>
  await api.put(`/mission-fee/bulk-edit/${id}?scope=${userScope}`, data);

export const getCurrentMissionFeeQuery = async ({ id, userScope }) =>
  await api.get(`/mission-fee/mission/${id}/current?scope=${userScope}`);

export const getMissionFeeByMissionIdArrayQuery = async ({ ids }) =>
  await api.get(`/mission-fee/mission/${ids}/current/arr`);
